<template>
  <div id="app">
  <navbar></navbar>
  <section>
  <div class="tile is-ancestor">
  <div class="tile is-vertical is-2">
  </div>
    <div class="tile is-vertical is-6">
      <div class="tile">
        <div class="tile is-parent is-vertical">
          <article class="tile is-child notification has-background-grey-lighter">
          <h1 class="title">Checkout</h1>
          <h3 class="">Please confirm the details below. </h3>
          <h4 class="">We process your payment through PayPal. We accept VISA, MasterCard, AmEx, PayPal. </h4>


          </article>

        </div>

      </div>

    </div>


  </div>

  </section>



    <section>


<div ref="thecart" >
     <h3>My Shopping Cart</h3>
     </div>
      <b-table
           detailed
           detail-key="naics"
           @details-open="(row, index) => $buefy.toast.open(`Expanded ${row.user.first_name}`)"
            :show-detail-icon="showDetailIcon"
            :opened-detailed="defaultOpenedDetails"
      :data="myOrders" >
      <template scope="props">
            <b-table-column field="naics" label="NAICS">{{props.row.naics}}</b-table-column>
            <b-table-column field="description" label="Description">{{props.row.description}}</b-table-column>
            <b-table-column field="region" label="Region">National</b-table-column>

            <b-table-column v-if="props.row.salesType == 'Exact'" field="sales" label="Sales ">{{props.row.salesExact}}</b-table-column>
            <b-table-column v-if="props.row.salesType != 'Exact'" field="sales" label="Sales ">{{props.row.salesrange}}</b-table-column>


</b-table-column>

<b-table-column field="price" label="Price">{{props.row.price}}</b-table-column>


          </template>

      </b-table>

      <div>

      <h1>Total Cost: {{ paypalTotal}} </h1>

      <b-button v-if="bypassPaypal" type="is-success" @click="payment_completed_cb_proxy()" >Purchase</b-button>

      <div>
      <div class="block" style="visibility:hidden">
    <b-radio v-model="radio"
        name="agreetoterms"
        native-value="Yes">
        Yes , I agree to the terms of the reports and service.
    </b-radio>
    <b-radio v-model="radio" default
        name="agreetoterms"
        native-value="No">
        No, I do not accept the terms of the reports and service.
    </b-radio>
    </div>
      </div>


      </div>

      <PayPal
      env="sandbox"
       :amount="paypalTotal"
       currency="USD"
       :items="myItems"
       :client="credentials"
       @payment-authorized="payment_authorized_cb"
    @payment-completed="payment_completed_cb"
    @payment-cancelled="payment_cancelled_cb"
       >
     </PayPal>
     <p v-if="isPayPalProblem">
        An error occurred with your PayPal payment or transaction was cancelled. Please try again.
</p>
     </section>

  </div>
</template>

<script>
import CardComponent from './CardComponent'
import Navbar from "./features/Navbar"
import 'buefy/dist/buefy.css'
import debounce from 'lodash/debounce'
import CartViewer from './CartViewer'
import axios from 'axios'
 import PayPal from 'vue-paypal-checkout'
 import { mapState } from "vuex";
 import { ORDER_PARAMETERS } from "../store/actions/order";
 import { CART_ADD , CART_PURCHASE, CART_RESTAPI } from "../store/actions/cart";
  export default {
  components: {
  PayPal,
    CardComponent,
      Navbar,
      CartViewer
},
      data() {
          return {
            isPayPalProblem: false,
            bypassPaypal: false,
            checkboxGroup: [],
            radioButton: [],
            checkRange: true,
            checkExact: false,
            showDetailIcon: false ,
            radio: "No",
            dropdown_id: [],
            defaultOpenedDetails: [],
            orders: [],
              data: [],
              thetotal: "10",
              selected_id: [],
              input_id: [],
              input_id2: [],
              myItems: [],
              selected: null,
              isFetching: false,
              credentials: {
  sandbox: 'ARK1S926MJ-vd2UJD1gp3gLGrOAO6LRlxJ8Z8AKEOmD30hptzI1JETpBbm2j_oPrhMHRBl7IMdYUGM_9',
  production: ''
}
          }
      },
      watch: {
  isPayPalProblem: function() {
    console.log(this.isPayPalProblem)
  },
  status(thenew, theold) {
  console.log("status:",theold,thenew )

  if( thenew=="success") {
  this.loadAxiosData()
  }
  }
},
mounted () {

  this.$store.commit(CART_RESTAPI, this.$api.REST_API )

  this.$store.commit(CART_RESTAPI, this.$api.REST_API)

this.myOrders.forEach((order, index, array) => {
var paypal_item =  {
    "name": "Norms and Ratios Report" + "-" + order.report,
    "description": order.naics + "-" + order.description ,
    "quantity": "1",
    "price": order.price,
    "currency": "USD"
    }
this.myItems.push(paypal_item)
});


},

      computed: {
      ...mapState({
      mapaxiosData: state => state.cart.axiosData,
      status: state => state.cart.status,
      myProducts: state => state.cart.products,
      myOrders: state => state.cart.orders,
      }),

          paypalTotal() {
          var total = 0.0
          this.myItems.forEach((element, index, array) => {
            total = total + parseFloat(element.price)
            });
            return total.toString()
          },
          isRange() {
          if( this.radio == "Range") {
            return true
          } else {
          return false
          }
          },
          computedgetIcon() {
            return "check"
          },
      },
      methods: {
      huh(index,naics) {
        console.log("index=",index,";naics=",naics)
        console.log("radio=",this.radio,";radiobutton=",this.radioButton)
      },

      getIcon(index,val) {
      console.log("getIcon(props.row.index,)",val,index,this.radioButton[index-1])
        return "check"
      },
      checkboxInput() {
      console.log("clickety-click",this.checkRange,this.checkExact)
      if( this.checkRange) {
        this.checkExact = false
      } else if (this.checkExact) {
      this.checkRange = false
      }
      },
      payment_completed_cb_proxy() {
        console.log("haha-checkout")
        this.isPayPalProblem = false
        var PayPalResponse =  { id: "PAYID-L2FWZAI2E937796UX7400501",
            intent: "sale",state: "approved",cart: "1H992079R7275922B",create_time: "2020-04-06T17:53:04Z",
            payer: { payment_method: "paypal",status: "VERIFIED",
              payer_info: {
                email: "sb-ebbnw1109778@personal.example.com", first_name: "John", middle_name: "John", last_name: "Doe",payer_id: "QJULWDC4ZLNX4",
                country_code: "US",shipping_address: {
                  recipient_name: "John Doe",line1: "1 Main St",  city: "San Jose",state: "CA",postal_code: "95131",country_code: "US" }}}}

                  this.$store.dispatch(CART_PURCHASE, PayPalResponse  ).then(() => {
                    this.$router.push({ name: "OrderConfirmation" });
                  });


      },
      payment_completed_cb(res){
    console.log("Thank you! We'll send you a confirmation email soon with your invoice. ");
    console.log(res);
    this.isPayPalProblem = false

    this.$store.dispatch(CART_PURCHASE, res  ).then(() => {
      this.$router.push({ name: "OrderConfirmation" });
    });

},
payment_authorized_cb(res){
    this.isPayPalProblem = false
    console.log(res);
},
payment_cancelled_cb(res){
    console.log("The payment process has been canceled. No money was taken from your account.");
    console.log(res);
    this.isPayPalProblem = true
},
doCustomSalesInput(naics) {
        this.orders.forEach((element, index, array) => {
        if (element.naics == naics) {
        this.orders[index].salesrange = this.input_id[element.index]
        }
          });

console.log("doCustomSalesInput:"+naics)
console.log(this.orders)
},
doCustomSales(naics) {

this.orders.forEach((element, index, array) => {
if (element.naics == naics) {
      if( this.selected_id[element.index] == "Input" ) {
        this.orders[index].salesinput = true

      } else {
      this.orders[index].salesinput = false
      this.orders[index].salesrange = this.selected_id[element.index]
      }
}

      });

    console.log("doCustomSales:"+naics)
    console.log(this.orders)
},
          // You have to install and import debounce to use it,
          // it's not mandatory though.
          deleteItem(naics) {
          this.orders = this.orders .filter(function( obj ) {
                return obj.naics !== naics;
              });
          console.log("Deleting NAICS="+naics)
    },
    addToCartDirect: function(description,naics) {
      // console.log("click me")
      var element = this.$refs['thecart'];
    var top = element.offsetTop;
    window.scrollTo(0, top);

    // this.radio.push("Range")
    // this.radioButton.push(3)
    console.log("radio=",this.radio,";radiobutton=",this.radioButton)

    var order = {naics: naics, description: description, price: "$24.99", salesinput:false, salesrange: null, index:this.orders.length+1 }
      this.orders.push(order)

    var product = {report: "Standard-1",  naics: naics, description: description, salesType: "Range", salesrange: null, salesExact:0 }
    this.$store.commit(CART_ADD, product)

    var paypal_item =  {
        "name": "Norms and Ratios Report",
        "description": order.naics + "-" + order.description ,
        "quantity": "1",
        "price": "24.99",
        "currency": "USD"
        }
    this.myItems.push(paypal_item)

      this.defaultOpenedDetails.push(naics)

    },
          addToCart: function() {
            // console.log("click me")
            var order = {naics: this.selected.naics, description: this.selected.description, price: "$24.99" , salesinput:false, salesrange: null ,index:this.orders.length+1}
            this.orders.push(order)

            var paypal_item =  {
                "name": "Norms and Ratios Report",
                "description": order.naics + "-" + order.description ,
                "quantity": "1",
                "price": "24.99",
                "currency": "USD"
                }
            this.myItems.push(paypal_item)

            this.defaultOpenedDetails.push(order.naics)
          //  this.radio.push("Range")
          //  this.radioButton.push(3)
        },
          checkoutNow: function() {
             console.log("Check Out")
             router.push({ name: "About" });

          },

                    getAsyncData: debounce(function (name) {
          //  console.log(name)
              if (!name.length) {
                  this.data = []
                  return
              }
              this.isFetching = true
              var URI = this.$api.REST_API + '/NAICS/' + name
              axios.get(URI)
              .then(({ data }) => {
            //          console.log(data)
                      this.data = []
                      // data.results.forEach((item) => this.data.push(item))
                      for (var i = 0, len = data.NAICS.length; i < len; i++) {
                          var element = data.NAICS[i]
              //            console.log(element)
                          var hit = {naics: element.naics, description: element.description }
                //          console.log(hit)
                        this.data.push(hit)
                        }
                      /*
                      data.results.forEach(function(element){
                          console.log(element)
                          var hit = {naics: element.release_date, description: element.title }
                          console.log(hit)
                        this.data.push(hit)
                        })
                        */
                  })
                  .catch((error) => {
                      this.data = []
                      throw error
                  })
                  .finally(() => {
                      this.isFetching = false
                  })
          }, 500)
      }
  }
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue